var ColorImage = /** @class */ (function () {
    function ColorImage(obj, id) {
        if (id) {
            this.id = id;
        }
        this.image_url = obj.image_url;
    }
    ;
    Object.defineProperty(ColorImage.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColorImage.prototype, "ImageUrl", {
        get: function () {
            return this.image_url;
        },
        enumerable: false,
        configurable: true
    });
    return ColorImage;
}());
export { ColorImage };
export function createColorImage(obj, id) {
    return new ColorImage(obj, id);
}
export function createColorImages(rawColorImages) {
    var colorImages = [];
    var rawColorImagesData = rawColorImages.data;
    for (var _i = 0, rawColorImagesData_1 = rawColorImagesData; _i < rawColorImagesData_1.length; _i++) {
        var rawColorImage = rawColorImagesData_1[_i];
        var colorImage = createColorImage(rawColorImage.attributes, rawColorImage.id);
        colorImages.push(colorImage);
    }
    return colorImages;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/product/colorImage.ts
// module id = 338
// module chunks = 0